export function getUrlParams(parameters, parameterName : string) {
  if (parameters.length > 0) {
    parameters = parameters.toLowerCase();
    const result = {};
    result[parameterName] = '';
    const paramArray = parameters.split('&');
    paramArray.forEach((param) => {
      const splitParamArray = param.split('=');
      if (splitParamArray.length > 0) {
        result[splitParamArray[0]] = decodeURIComponent(splitParamArray[1]);
      }
    });
    return result[parameterName].trim();
  }
  return null;
}